/* eslint-disable no-unused-vars */
import React from 'react';
import styles from '../search.scss';

const ClubFilters = (props) => {
    const {
        search,
        handleFilterClick,
        state,
        userLoggedIn,
        showPowerPopup,
        hideFilters,
        isPowerUser,
        _this,
    } = props;

    return null;
};

export default ClubFilters;
